module.exports = __webpack_public_path__ + "img/resized-APP-0006-2.02ca2cde.png";